'use client'

import { useLocale, useTranslations } from 'next-intl'
import { FadeOverlay } from '@/components/fade-overlay'
import { NeotasteMap } from '@/components/map/neotaste-map'
import { getNeotasteMapPositionProps } from '@/components/map/utils/neotaste-map-helpers'
import { ITranslationKey } from '@/components/t'
import { CommonPlacesSearch } from '@/features/common/common-places-search'
import { ICommonProps } from '@/features/common/common-props'
import { IGoogleAddressOption } from '@/features/google-places/google-places-restaurants-search'
import { Locale } from '@/setup/locales'

export const CommonMapSearch = ({
    tBaseKey,
    onSelect,
}: ICommonProps & { onSelect: (option: IGoogleAddressOption | null) => void }) => {
    const locale = useLocale()
    const t = useTranslations()

    return (
        <div className="w-full flex flex-col-reverse md:flex-row relative md:max-h-[560px]">
            <div className="w-full md:w-1/2 md:bg-[#F4F4F4] flex items-center justify-center px-4 md:px-0 mt-4 md:mt-0">
                <div className="flex flex-col max-w-[499px]">
                    <div className="flex flex-row mb-4 sticky">
                        <h2 className="mr-2 text-[24px] leading-[32px] md:text-left text-center">
                            {t(`${tBaseKey}.mapSearch.title` as ITranslationKey)}
                        </h2>
                    </div>

                    <CommonPlacesSearch
                        onSelect={onSelect}
                        tBaseKey={tBaseKey}
                        containerClassName="justify-center md:justify-start"
                    />
                </div>
            </div>

            <div className="relative w-full md:w-1/2 min-h-[400px] max-h-[400px] md:min-h-[560px] md:max-h-[560px]">
                <NeotasteMap
                    disableRestaurantClicks
                    withInitialDelay={false}
                    className="w-full min-h-[inherit] max-h-[inherit] bg-gray-100"
                    loadWithPlacesLibrary
                    {...getNeotasteMapPositionProps(locale as Locale, {
                        [Locale.DE_DE]: {
                            zoomDesktop: 5.8,
                        },
                    })}
                />

                <FadeOverlay className="absolute md:hidden bottom-[-2px]" />
            </div>
        </div>
    )
}
